import { Button, Box } from '@mui/material';
import { stylesCustomButton } from './stylesCustomButton';

export const CustomButton = ({ buttonNane, onClick }: { buttonNane: string, onClick: (any?: any) => void }) => {
  return (
    <Box sx={{
      textAlign: 'center',
      paddingBottom: '20px',
    }}>
      <Button
        variant="contained"
        onClick={onClick}
        sx={stylesCustomButton.button}
      >
        {buttonNane}
      </Button>
    </Box>
  );
};